import {
  SET_FOLDER_ID_FOR_NEW_PAGE
} from '../const/action_types.js';

export const setFolderIdForNewPage = (folderId) => {
  return {
    type: SET_FOLDER_ID_FOR_NEW_PAGE,
    folderId
  };
};